// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sortArrowIcon[data-v-72a7a6ae]{margin-top:-4px!important;margin-left:-4px!important}.noNotificationsFoundIcon[data-v-72a7a6ae]{font-size:150px!important}.sortByBar[data-v-72a7a6ae]{min-height:50px!important}.noBorder[data-v-72a7a6ae]{border:none!important}", ""]);
// Exports
module.exports = exports;
